module.exports = __webpack_public_path__ + "static/img/book41.d39fd4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book41.jpg
// module id = +zzN
// module chunks = 1